import { Collection, Ref } from "@tblabs/truffle";
import { StepData } from "../../Step/StepData";
import { RentBasketItem } from "../../../Models/Basket/RentBasketItem";
import { RawRentBasketItem } from "../../../Models/Basket/RawRentBasketItem";
import { SaleBasketItem } from "../../../Models/Basket/SaleBasketItem";
import { RawSaleBasketItem } from "../../../Models/Basket/RawSaleBasketItem";
import { BasketItem } from "../../../Models/Basket/BasketItem";
import { BasketItemType } from "../../../Models/Basket/BasketItemType";
import { AddToBasketStepRawData } from "./AddToBasketStepRawData";
import { AddToBasketStepState } from "./AddToBasketStepState";


export class AddToBasketStepData extends StepData
{
    public BasketItems = new Collection<BasketItem>();
    public RejectionReason: Ref<string> = new Ref<string>("");
    public AcceptedTime: Ref<Date> = new Ref<Date>(new Date(0));

    constructor(raw: Partial<AddToBasketStepRawData>)
    {
        super(raw);

        this.State.value ||= AddToBasketStepState.New;

        if (raw?.BasketItems)
            this.BasketItems.Load(...raw.BasketItems.map(x =>
            {
                switch (x.Type)
                {
                    case BasketItemType.Sale:
                        return new SaleBasketItem(x as RawSaleBasketItem);
                    case BasketItemType.Rent:
                        return new RentBasketItem(x as RawRentBasketItem);
                    default:
                        throw new Error(`Nieznany typ produktu: ${x.Type}`);
                }
            }) || []);

        this.RejectionReason.value = raw?.RejectionReason || "";
        this.AcceptedTime.value = new Date(raw?.AcceptedTime || 0);
    }
}
